<kiosk-wizard [step]="2">
  <div class="kiosk-hw100">
    <kiosk-template
      mainTitle="app.components.wizard.steps.scan-qr-code-no-appointment-scheduled.title"
      subtitle="app.components.wizard.steps.scan-qr-code-no-appointment-scheduled.sub-title"
      image="something-went-wrong"
    >
    </kiosk-template>
    <div class="kiosk-bottom-button-container">
      <button
        pButton
        pRipple
        type="button"
        label="{{'app.components.wizard.steps.scan-qr-code-no-appointment-scheduled.scan-again' | transloco}}"
        (click)="navigate()"
        class="p-button-secondary btn-xl"
      ></button>
    </div>
  </div>
</kiosk-wizard>
